module.exports = __webpack_public_path__ + "static/media/pay-top-success6.6783fc50.png";